const config = {
	// File upload's restrictions
	extensions: {
		image: ['.jpg', '.jpeg', '.gif', '.png', '.bmp', '.svg', '.webp'],
		office: [
			'.doc', '.docx', '.sxw', '.stw', '.xls', '.xlsx', '.sxc', '.stc',
			'.ppt', '.pptx', '.pptm', '.pps', '.sxi', '.sti', '.rtf', '.txt'
		],
		audio: ['.mp3', '.aac', '.wav'],
		video: ['.avi', '.mov', '.mp4', '.mpg', '.mpeg'],
		other: ['.pdf', '.zip', '.rar', '.7zip', '.7z']
	}
};

export default config;
